// ./pages/About/index.jsx
import React from "react";
import Contactsubbanner from "../../components/contactsubbanner";
import Contactform from "../../components/contactform";
import Contactmap from "../../components/contactmap";

const Contact = () => {
  return (
    <>
     <Contactsubbanner />
     <Contactform />
     <Contactmap />
    </>
  );
};

export default Contact;